export default {
    BASE_URL: process.env.VUE_APP_BASE_URL,

    API_HOST: process.env.VUE_APP_HOST,
    API_PREFIX: "api/frontend",

    APP_STORE_LINK: process.env.VUE_APP_APP_STORE_LINK,
    PLAY_STORE_LINK: process.env.VUE_APP_PLAY_STORE_LINK,

    CS_ADDRESS: process.env.VUE_APP_CS_ADDRESS,
    CS_LANDLINE: process.env.VUE_APP_CS_LANDLINE,
    CS_MOBILE: process.env.VUE_APP_CS_MOBILE,
    CS_EMAIL: process.env.VUE_APP_CS_EMAIL,

    FACEBOOK_ID: process.env.VUE_APP_PROVIDER_FACEBOOK_ID,
    GOOGLE_ID: process.env.VUE_APP_PROVIDER_GOOGLE_ID,
    
    FACEBOOK_PAGE_LINK: process.env.VUE_APP_FACEBOOK_PAGE_LINK,
    INSTAGRAM_PAGE_LINK: process.env.VUE_APP_INSTAGRAM_PAGE_LINK,
}